export type AuthTarget = 'select' | 'corp' | 'owner';

export type BlockKind = 'none' | 'unverified' | 'reviewing';

export enum SubmittedAuthType {
    /** 已提交企业认证 */
    Corp = 'corp',
    /** 已提交个人认证 */
    Owner = 'owner',
    /** 企业和个人认证均已提交 */
    Identity = 'identity'
}

export interface GuardOptions {
    onEntryClick?: (type: AuthTarget) => void;
}
